import { render, staticRenderFns } from "./ArticleSingle.vue?vue&type=template&id=0e029753&"
import script from "./ArticleSingle.vue?vue&type=script&lang=js&"
export * from "./ArticleSingle.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports